// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1BO04","row":"Node_row__1Q13W","label":"Node_label__1PUe4","footer":"Node_footer__38hPO"};